import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 100vh;
  }
`

export const Logo = styled.img`
`

export const MissionWrapper = styled.div`
  
  width: 100%;
  max-width: 95vw;
  margin: 0 auto;
  
  
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
`

export const MissionContainer = styled.div<any>`
  width: 100%;
  height: 100%;
  max-width: 85%;
  max-height: 50vh;
  padding: 1vh 1vw 0 calc(40px / 2);

  overflow: auto;
  scroll-behavior: smooth;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  & {
    scrollbar-width: thin;
    scrollbar-color: #fff rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background-color: ${(props:any) => `${props.gameColor}40`};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props:any) => props.gameColor};
    border-radius: 20px;
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    max-height: unset;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 100%;

    & {
      scrollbar-width: thin;
      scrollbar-color: #fff rgba(255,255,255, .19);
    }

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background-color: ${(props:any) => `${props.gameColor}40`};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props:any) => props.gameColor};
    border-radius: 20px;
  }
  }
`

export const MissionCards = styled.div`
  width: 100%;
  padding-left: 50px;
  position: relative;
  max-height: 70vh;

  scroll-behavior: smooth;

  @media (max-width: ${customTheme.breakpoints[1]}) {    
    padding-top: 10px;
  }

  &:before {
    /* content: ''; */
    width: 4px;
    height: 54%;
    background: ${customTheme.colors.white};
    position: absolute;
    top: 100%;
    top: 45px;
    left: -1px;

    & + & {
      height: 64%;
    }
  }
`
